import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "./projectIqTokens";

export const useProjectIqSharedButtonStyles = makeStyles({
  tealButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    height: "46px",
    padding: "0 16px",
    borderRadius: "12px",
    border: "none",
    background: projectIqTokens.teal,
    color: "#ffffff",
    fontSize: "13.5px",
    fontWeight: "700",
    cursor: "pointer",
    flexShrink: 0,
    whiteSpace: "nowrap",
    fontFamily: projectIqTokens.fontFamily,
    boxShadow: "rgba(14, 154, 167, 0.25) 0px 4px 12px",
    ":hover": {
      background: projectIqTokens.teal2,
    },
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.teal}`,
      outlineOffset: "2px",
    },
  },
});
